import React from 'react';

import { TooltipWrapper } from '@zapier/design-system';
import MenuMoreToggler from 'app/common/components/MenuMoreToggler';

type Props = {
  message: string;
};

function LockedNavCog({ message }: Props) {
  return (
    <TooltipWrapper content={message}>
      {() => <MenuMoreToggler disabled={true} />}
    </TooltipWrapper>
  );
}

export default LockedNavCog;
